
function BufferEntries() {
    /// <summary>
    /// This object provides js functions for the Widget.Buffer.BufferEntries.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 4.4.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 4.3.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}

BufferEntries.prototype = new vcTemplate();

BufferEntries.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.showInfo("", "", false);

        me.visual.find(".btnDelete").button();
        me.visual.find(".btnDelete").off("click").on("click", function() {
            me.delete($(this));
        });


    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


BufferEntries.prototype.delete = function (obj) {
    /// <summary>
    ///  This function sends a request for deleting the selected buffer entries.
    /// </summary>
    var me = this;

    try {
 
        if (me.error) {
            return false;
        }

        if (confirm('Do you really want to delete the selected buffer entries?', 'Validation')) {
            if (confirm('Really?', 'Validation')===false) {return false;}
        } else {
            return false;
        }

        var dataType = obj.attr("data-type");
        if (dataType.length===0) {return false};
        var dataState = parseInt(obj.attr("data-state"),10);
       
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2,JSON.stringify({'DataType':dataType,'BufferStatus':dataState}),
       function (result) {
           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result === false) {
               me.showMessage(me.resources.err_saveData, true); return false;
           }
           obj.hide();
           return true;
       });

        return false;
    } catch (ex) { me.writeError('update', ex); return false }

}

BufferEntries.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function calls hides the content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
             me.visual.find("#divList").css("opacity", 0.3);
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};